export class WindowEventHandler {
  static scroll = { position: { x: 0, y: 0 }, direction: { x: 'right', y: 'down' } };
  #resizeTimer;
  #htmlElement;

  constructor() {
    this.#htmlElement = document.documentElement;
    this.#updateScrollProperties();
    this.#bindEvents();
  }

  #bindEvents() {
    window.addEventListener('resize', this.#doOnResize);
    window.addEventListener('scroll', this.#doOnScroll);
  }

  #doOnResize = () => {
    this.#htmlElement.classList.add('resizing');
    clearTimeout(this.#resizeTimer);
    this.#resizeTimer = setTimeout(() => {
      this.#htmlElement.classList.remove('resizing');
    }, 100);
  };

  #doOnScroll = () => {
    this.#updateScrollProperties();
  };

  #setScrollProperties() {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    const currentScroll = WindowEventHandler.scroll;

    currentScroll.direction.x = scrollX < currentScroll.position.x ? 'left' : 'right';
    currentScroll.direction.y = scrollY < currentScroll.position.y ? 'up' : 'down';
    currentScroll.position.x = scrollX;
    currentScroll.position.y = scrollY;
  }

  #updateScrollProperties() {
    this.#setScrollProperties();
    this.#htmlElement.classList.toggle('scrolling', window.scrollY > 0);
  }
}
